//import { MULTIFORM } from "./constants/specialContentTypes";

const getBimPointFiles = (data) => ({
  method: "GET",
  url: "/bim_model_points",
  data,
});

export const bimPointApi = {
  getBimPointFiles
};
